import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Routes
import routes from "routes";

function AdminIt() {
  const navigate = useNavigate();
  const location = useLocation();
  const props = location.state;
  useEffect(() => {
    if (props === null) {
      navigate("/ndrs-gsb-register/sign-in");
    }
  }, []);
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "https://ln15.gsb.or.th/ndrs",
          label: "GSB NDRS Website",
          color: "default",
        }}
        transparent
        light
      />
      <MKBox
        minHeight="45vh"
        width="100%"
        bgColor="#1e88e5"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h2"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              การลงทะเบียนเข้าร่วมมาตรการ
              <br />
              ผ่อนปรนเงื่อนไขการชำระหนี้
            </MKTypography>
            <MKTypography variant="h5" color="white" opacity={1} mt={1} mb={3}>
              มาตรการให้ความช่วยเหลือลูกหนี้ที่มีสถานะเป็นหนี้เสียที่มีภาระหนี้เงินต้นและดอกเบี้ยไม่เกิน
              1 แสนบาท
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" py={{ xs: 6, sm: 12 }}>
          <Container>
            <Grid container item xs={12} justifyContent="center">
              <Grid container justifyContent="center" py={2} spacing={1}>
                <MKButton
                  variant="contained"
                  color="primary"
                  onClick={() => navigate("/ndrs/export", { state: { user: props.user } })}
                >
                  Export ข้อมูลลูกค้าลงทะเบียน
                </MKButton>
                &nbsp;
                <MKButton
                  variant="contained"
                  color="success"
                  onClick={() =>
                    navigate("/ndrs/importCallcenter", { state: { user: props.user } })
                  }
                >
                  Import เปลี่ยนลำดับการตัด
                </MKButton>
                &nbsp;
                <MKButton
                  variant="contained"
                  color="info"
                  onClick={() => navigate("/ndrs/reversecid", { state: { user: props.user } })}
                >
                  Import Reverse
                </MKButton>
              </Grid>
              <Grid container justifyContent="center" py={2} spacing={1}>
                <MKButton
                  variant="contained"
                  color="dark"
                  onClick={() => navigate("/ndrs-gsb-register/sign-in")}
                >
                  Logout
                </MKButton>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>
    </>
  );
}

AdminIt.defaultProps = {
  user: {},
};
AdminIt.propTypes = {
  user: PropTypes.shape({
    title: PropTypes.string,
    postalCode: PropTypes.string,
    displayName: PropTypes.string,
    otherPager: PropTypes.string,
    department: PropTypes.string,
    streetAddress: PropTypes.string,
    employeeType: PropTypes.string,
    employeeID: PropTypes.string,
    division: PropTypes.string,
    token: PropTypes.string,
    accessToken: PropTypes.string,
    isLogin: PropTypes.bool,
    isAdmin: PropTypes.bool,
    isCallCenter: PropTypes.bool,
    isIt: PropTypes.bool,
  }),
};

export default AdminIt;
